import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import config from '../../../config.json'
import { MOVIE } from '../../../constants/itemTypes'
import EditAllMoviesListCheck from './EditAllMoviesListCheck'
import checkFSKExist from '../../../functions/checkFSKExist'


class EditAllMoviesListItem extends Component {
    constructor(props) {
        super(props)
    }

    getAttrData(key, data) {
        if(data && data.hasOwnProperty(key)) {
            return data[key]
        } else {
            return false
        }
    }

    getData(keys) {
        const { itemData } = this.props

        let data = this.getAttrData(keys[0], itemData)

        if(1 < keys.length) {
            for(let i = 1; i < keys.length; i++)  {
                data = this.getAttrData(keys[i], data)
            }
        }

        return data
    }

    getCheck(keys, check) {
        const data = this.getData(keys)

        if('notEmpty' === check) {
            return data
        } else if('lengthNotZero' === check) {
            return data && data.length > 0
        } else if('fskExist' === check) {
            return checkFSKExist(data)
        }  else {
            return false
        }
    }

    render() {
        const { itemData, checkList, evenOddClass } = this.props

        return (
            <li  className={"list-item " + evenOddClass}>
                <Link
                    to={`${config.routes.movies.path}/${MOVIE}/${itemData.id}/edit-item`}
                    className='moviedata-form-wrapper'
                >
                    <div className='movie-check-wrapper container-item'>
                        <div className="icon button-edit button-edit-selection button "></div>
                        <div className='text-small-light'>{itemData.title}</div>
                        <div className='checklist container-checks'>
                            {checkList.map(({keys, check}, index)  => (
                                <EditAllMoviesListCheck
                                    key={index}
                                    check={this.getCheck(keys, check)}
                                />
                            ))}
                        </div>
                    </div>
                </Link>
            </li>
        )
    }
}

export default EditAllMoviesListItem